<script setup>
import AdvancedFeedbackManager from '@/views/apps/feedback/list/AdvancedFeedbackManager.vue'

definePage({
  meta: {
    action: 'read',
    subject: 'feedbacks',
    layoutWrapperClasses: 'layout-content-height-fixed',
  },
})
</script>

<template>
  <AdvancedFeedbackManager />
</template>

